import React from "react";
import { FaChevronDown, FaSignOutAlt } from "react-icons/fa";

const SideDrawer = ({ isOpen, toggleDrawer, navigate, toggleDropdown, dropdown }) => {
  return (
    <div
      className={`fixed top-0 left-0 w-64 h-full bg-white shadow-lg transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } transition-transform duration-300 ease-in-out z-50`}
    >
      {/* Close Button */}
      <button
        className="absolute top-4 right-4 text-gray-800 text-xl"
        onClick={toggleDrawer}
      >
        ✖
      </button>

      {/* Side Drawer Links */}
      <div className="mt-8 flex flex-col space-y-4">
        <button
          className="text-gray-800 text-md font-semibold py-2 px-6 hover:bg-blue-100"
          onClick={() => {
            navigate("/post-property");
            toggleDrawer();
          }}
        >
          Post Property
        </button>

        {/* Home Loan Dropdown */}
        <div className="relative">
          <button
            className="text-gray-800 text-md font-semibold py-2 px-6 flex justify-between items-center w-full hover:bg-blue-100"
            onClick={() => toggleDropdown("homeLoan")}
          >
            Home Loan
            <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "homeLoan" && (
            <ul className="pl-6 bg-gray-50">
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/apply-for-loans");
                  toggleDrawer();
                }}
              >
                Apply for Loan
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/home-loan-application");
                  toggleDrawer();
                }}
              >
                Eligibility Calculator
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/home-loan-application");
                  toggleDrawer();
                }}
              >
                EMI Calculator
              </li>
            </ul>
          )}
        </div>

        {/* Other Dropdowns: Buy, Sell, Rent */}
        {/* Similar to Home Loan Dropdown */}
        {/* Buy Dropdown */}
        <div className="relative">
          <button
            className="text-gray-800 text-md font-semibold py-2 px-6 flex justify-between items-center w-full hover:bg-blue-100"
            onClick={() => toggleDropdown("buy")}
          >
            Buy
            <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "buy" && (
            <ul className="pl-6 bg-gray-50">
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/buy-a-property");
                  toggleDrawer();
                }}
              >
                Buy a Property
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/no-brokerage-policy");
                  toggleDrawer();
                }}
              >
                No Brokerage Policy
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/home-buying-guide");
                  toggleDrawer();
                }}
              >
                Home Buying Guide
              </li>
            </ul>
          )}
        </div>

        <div className="relative">
          <button
            className="text-gray-800 text-md font-semibold py-2 px-6 flex justify-between items-center w-full hover:bg-blue-100"
            onClick={() => toggleDropdown("sell")}
          >
            Sell
            <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "sell" && (
            <ul className="pl-6 bg-gray-50">
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/post-property");
                  toggleDrawer();
                }}
              >
                Sell Your Property
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/home-worth-calculator");
                  toggleDrawer();
                }}
              >
                Home Worth Calculator
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/home-selling-guide");
                  toggleDrawer();
                }}
              >
                Home Selling Guide
              </li>
            </ul>
          )}
        </div>

        <div className="relative">
          <button
            className="text-gray-800 text-md font-semibold py-2 px-6 flex justify-between items-center w-full hover:bg-blue-100"
            onClick={() => toggleDropdown("rent")}
          >
            Rent
            <FaChevronDown className="ml-2 text-sm" />
          </button>
          {dropdown === "buy" && (
            <ul className="pl-6 bg-gray-50">
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/rent-a-property");
                  toggleDrawer();
                }}
              >
                Rent a Property
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/no-brokerage-policy");
                  toggleDrawer();
                }}
              >
                No Brokerage Policy
              </li>
              <li
                className="py-2 hover:bg-blue-100 cursor-pointer"
                onClick={() => {
                  navigate("/renters-guide");
                  toggleDrawer();
                }}
              >
                Renters Guide
              </li>
            </ul>
          )}
        </div>

        <button
          className="text-gray-800 text-md font-semibold py-2 px-6 hover:bg-blue-100"
          onClick={() => {
            navigate("/become-our-partner");
            toggleDrawer();
          }}
        >
          Become Our Partner
        </button>

        <button
          className="text-gray-800 text-md font-semibold py-2 px-6 hover:bg-blue-100"
          onClick={() => {
            navigate("/knowledge-center");
            toggleDrawer();
          }}
        >
          Knowledge Center
        </button>

        <button
          className="text-gray-800 text-md font-semibold py-2 px-6 hover:bg-blue-100"
          onClick={() => {
            navigate("/about-us");
            toggleDrawer();
          }}
        >
          About Us
        </button>

        <button
          className="text-gray-800 text-md font-semibold py-2 px-6 hover:bg-blue-100"
          onClick={() => {
            navigate("/contact-us");
            toggleDrawer();
          }}
        >
          Contact Us
        </button>

        {/* Log In */}
        <button
          className="bg-primaryOrange text-white py-2 px-6 rounded-lg hover:bg-orange-600 mx-6 flex justify-center items-center"
          onClick={() => {
            navigate("/login");
            toggleDrawer();
          }}
        >
          <FaSignOutAlt className="mr-2" />
          Log In
        </button>
      </div>
    </div>
  );
};

export default SideDrawer;
